import {SignLandingPageType} from '../sign-landing-pages.types';

export type SignLandingPageParamsType = Partial<{
	id: string;
	user: string; // signer name
	creator: string; // creator name
	rejected_by: string; // reject cycle user name
}>;

export type SignLandingPageParam = keyof SignLandingPageParamsType;

export function generateUrlFromTemplate(url: SignLandingPageType, params: Partial<Record<SignLandingPageParam, string>>): string {
	let urlWithParams: string = url;
	Object.keys(params).forEach((param: SignLandingPageParam) => {
		urlWithParams = urlWithParams.replace(`/:${param}`, `/${params[param]}`);
	});
	return `sign/landing/${urlWithParams}`;
}
